import { render, staticRenderFns } from "./AccrualsEstimationRulesEditor.vue?vue&type=template&id=dc5f2f70&scoped=true"
import script from "./AccrualsEstimationRulesEditor.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimationRulesEditor.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimationRulesEditor.vue?vue&type=style&index=0&id=dc5f2f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5f2f70",
  null
  
)

export default component.exports